import { useState } from 'react';
import HeaderInvoiceRequest from '../../organism/header-invoice-request/HeaderInvoiceRequest';
import ManageCountries from '../../organism/manage-countries/manageCountries';
import Aside from '../../templates/aside/aside';
import Wrapper from '../../templates/wrapper/Wrapper';
import { useTranslation } from "react-i18next";

function Countries({props}) {
    const [translate] = useTranslation("global");
    const [blur, setBlur] = useState(false);
    const title = translate('administrator.manageCountries.title');
    const description = translate('administrator.manageCountries.description');


    return (
        <Wrapper aside={ <Aside blur={blur} setBlur={setBlur} /> } blur={blur} >
            <HeaderInvoiceRequest title={title} description={description} />
            <ManageCountries />
        </Wrapper>
    )
}

export default Countries;